export const TPA_EXPERIMENTS = {
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  BENEFIT_PROGRAMS_ENABLED: 'specs.membership.BenefitProgramsEnabled',
  FIX_MOBILE_CHECKOUT: 'specs.membership.FixMobileCheckout',
  ERROR_HANDLER_TPA: 'specs.membership.ErrorHandlerTpa',
  ECOM_GEOIP_ADDRESS: 'specs.membership.EcomGeoIpAddress',
  SETTINGS_EVENTS_FIX: 'specs.membership.SettingsEventsFix',
  BUTTON_HOVER_SETTINGS_EDITOR: 'specs.membership.ButtonHoverSettingsEditor',
  BUTTON_HOVER_SETTINGS_VIEWER: 'specs.membership.ButtonHoverSettingsViewer',
  PLAN_LIST_V2: 'specs.membership.PlanListV2',
  CHECKOUT_TRIGGER_ON_LOGIN_ONCE: 'specs.membership.CheckoutTriggerOnLoginOnce',
  SUGGEST_ECOM_MIGRATION: 'specs.pricingPlans.SuggestEcomMigration',
  AUTOINSTALL_ECOM_PAGES: 'specs.PricingPlans.AutoinstallMissingEcomPages',
  IMPROVE_ECOM_LOADING_STATE: 'specs.PricingPlans.ImproveEcomLoadingState',
  START_DATE_FUNCTIONS: 'specs.membership.ShowStartDateFunctionTPA'
};
//# sourceMappingURL=tpa.js.map